import {
    AlertIcon,
    notifyWithAlertOrToast,
} from "../../components/global/alert/Alert";
import { all, takeEvery } from "redux-saga/effects";
import t from "../../i18n/i18next";
import { submitAwsMarketplaceActivation } from "../actions/awsmarketplace";

function* alertSuccess() {
    notifyWithAlertOrToast(
        t("redux.alertSuccess.youHaveSuccessfullyLinked"),
        undefined,
        AlertIcon.SUCCESS
    );
    yield;
}

function* awsMarketplaceSaga() {
    yield all([
        takeEvery(submitAwsMarketplaceActivation.type_success, alertSuccess),
    ]);
}

export default awsMarketplaceSaga;
